


















































import { PROPERTY_AMENITY_GROUPS } from '@/constants/property-amenity-groups.constant';
import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { compass } from '@resclick/compass';
import { Component, Mixins } from 'vue-property-decorator';
import AmenitiesList from './amenities-list.tab.vue';

@Component({
  components: { AmenitiesList },
})
export default class TabAmenities extends Mixins(ModalTabMixin) {
  currentModule = this.amenitiesGroups[0].modules[0];

  get amenitiesGroups() {
    return PROPERTY_AMENITY_GROUPS;
  }

  get formSchema() {
    return PROPERTY_AMENITY_GROUPS.flatMap((group) => {
      const { modules = [] } = group;
      return (modules as []).flatMap((module: { children: never }) => module.children);
    });
  }

  getForm() {
    return compass.do('properties', 'findOne', {
      params: { propertyId: this.id || '' },
      select: ['+amenities'],
    });
  }

  created() {
    this.form = this.$crsForm('properties', 'update', {
      amenities: {},
    });

    this.$on('update-data', () => {
      this.getForm()
        .then((res) => res.data)
        .then((data) => {
          this.form = this.$crsForm('properties', 'update', data);
        });
    });
  }
}
